import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

export default function EditorMail() {
    const [archivo, setArchivo] = useState(null);
    const [password, setPassword] = useState("");
    const [asunto, setAsunto] = useState("");
    const [htmlContenido, setHtmlContenido] = useState("");
    const [enviando, setEnviando] = useState(false);
    const [resultado, setResultado] = useState(null);
    const [infoExcel, setInfoExcel] = useState(null);

    // ==========================================
    // SELECCIONAR Y ANALIZAR EXCEL
    // ==========================================
    const seleccionarArchivo = (event) => {
        const archivoSeleccionado = event.target.files[0];

        if (!archivoSeleccionado) {
            setArchivo(null);
            setInfoExcel(null);
            return;
        }

        setArchivo(archivoSeleccionado);
        setResultado(null);

        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const nombreHoja = workbook.SheetNames[0];
                const hoja = workbook.Sheets[nombreHoja];
                const jsonData = XLSX.utils.sheet_to_json(hoja, { header: 1 });

                if (jsonData.length > 0) {
                    const nombresColumnas = jsonData[0] || [];
                    const totalColumnas = nombresColumnas.length;
                    const totalRegistros = jsonData.slice(1).filter(fila => fila.some(celda => celda !== "")).length;

                    setInfoExcel({
                        totalRegistros,
                        totalColumnas,
                        columnas: nombresColumnas
                    });
                } else {
                    setInfoExcel({ totalRegistros: 0, totalColumnas: 0, columnas: [] });
                }
            } catch (error) {
                console.error("Error al leer el archivo Excel:", error);
                alert("No se pudo leer el archivo Excel.");
                setInfoExcel(null);
            }
        };

        reader.readAsArrayBuffer(archivoSeleccionado);
    };

    // ==========================================
    // ENVIAR EMAILS
    // ==========================================
    const enviarEmails = () => {
        if (!archivo) {
            alert("Seleccioná un archivo Excel.");
            return;
        }
        if (!password.trim()) {
            alert("Ingresá la contraseña.");
            return;
        }
        if (!asunto.trim()) {
            alert("Ingresá un asunto.");
            return;
        }
        if (!htmlContenido.trim()) {
            alert("El contenido del correo está vacío.");
            return;
        }

        setEnviando(true);
        setResultado(null);

        // Envolvemos el HTML en una estructura limpia con fondo blanco forzado
        const htmlLimpio = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="utf-8">
                <style>
                    body { background-color: #ffffff !important; margin: 0; padding: 20px; font-family: Arial, sans-serif; color: #333333; }
                    .container { background-color: #ffffff !important; width: 100%; max-width: 600px; margin: 0 auto; }
                </style>
            </head>
            <body>
                <div class="container">
                    ${htmlContenido}
                </div>
            </body>
            </html>
        `;

        const formData = new FormData();
        formData.append("password", password);
        formData.append("html", htmlLimpio);
        formData.append("asunto", asunto); // <-- ¡Asunto agregado al FormData aquí!
        formData.append("archivo", archivo);

        axios.post("https://wwwp.isepsantafe.net.ar/inscripciones/enviar-html-excel", formData)
            .then((respuesta) => {
                setResultado(respuesta.data);
                alert("Proceso finalizado.");
            })
            .catch((error) => {
                console.error("Error enviando:", error);
                if (error.response) {
                    setResultado(error.response.data);
                    alert(error.response.data?.detail || error.response.data?.error || "FastAPI devolvió un error.");
                } else {
                    setResultado({ error: error.message });
                    alert("No se pudo conectar con FastAPI.");
                }
            })
            .finally(() => {
                setEnviando(false);
            });
    };

    return (
        <div style={{ width: "100%", minHeight: "100vh", background: "#ffffff", paddingBottom: "40px" }}>
            <div style={{ padding: "20px", background: "#eef3f8", borderBottom: "1px solid #d5dce3" }}>
                <h3 style={{ marginTop: 0, color: "#0b2f5b", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Enviar correo masivo</span>
                    <a href="https://html5-editor.net" target="_blank" rel="noopener noreferrer" style={{ fontSize: "0.75rem", fontWeight: "normal" }}>Abrir editor</a>
                </h3>

                {/* ASUNTO */}
                <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                        Asunto del correo
                    </label>
                    <input
                        type="text"
                        value={asunto}
                        onChange={(e) => setAsunto(e.target.value)}
                        placeholder="Ej: Hola, información importante"
                        style={{ width: "600px", maxWidth: "100%", padding: "10px", border: "1px solid #ccc", borderRadius: "5px", boxSizing: "border-box" }}
                    />
                    <div style={{ marginTop: "6px", fontSize: "12px", color: "#666" }}>
                        Variables disponibles: <strong>{`{{nombre}}`}</strong> <strong>{`{{dni}}`}</strong>
                    </div>
                </div>

                {/* ARCHIVO EXCEL */}
                <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                        Archivo Excel
                    </label>
                    <input type="file" accept=".xlsx,.xls" onChange={seleccionarArchivo} />

                    {archivo && infoExcel && (
                        <div style={{ marginTop: "10px", padding: "10px", background: "#ffffff", border: "1px solid #d5dce3", borderRadius: "5px", fontSize: "13px" }}>
                            <div>📄 Archivo: <strong>{archivo.name}</strong></div>
                            <div>📊 Total de registros: <strong>{infoExcel.totalRegistros}</strong></div>
                            <div>🗂️ Total de columnas: <strong>{infoExcel.totalColumnas}</strong></div>
                            <div style={{ marginTop: "5px" }}>
                                🏷️ <strong>Columnas detectadas:</strong>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginTop: "4px" }}>
                                    {infoExcel.columnas.map((col, idx) => (
                                        <span key={idx} style={{ background: "#e2e8f0", padding: "2px 6px", borderRadius: "4px", fontSize: "12px", fontFamily: "monospace" }}>
                                            {col}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* PASSWORD */}
                <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                        Contraseña
                    </label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Contraseña de seguridad"
                        style={{ width: "300px", maxWidth: "100%", padding: "10px", border: "1px solid #ccc", borderRadius: "5px", boxSizing: "border-box" }}
                    />
                </div>

                {/* BOTÓN ENVIAR */}
                <button
                    onClick={enviarEmails}
                    disabled={!archivo || !password || !asunto || !htmlContenido || enviando}
                    style={{
                        padding: "12px 25px",
                        border: "none",
                        borderRadius: "5px",
                        backgroundColor: archivo && password && asunto && htmlContenido && !enviando ? "#198754" : "#999999",
                        color: "#ffffff",
                        fontSize: "15px",
                        fontWeight: "bold",
                        cursor: archivo && password && asunto && htmlContenido && !enviando ? "pointer" : "not-allowed"
                    }}
                >
                    {enviando ? "Enviando..." : "Enviar correos"}
                </button>
            </div>

            {/* EDITOR DE HTML LIMPIO */}
            <div style={{ padding: "20px" }}>
                <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px", color: "#0b2f5b" }}>
                    Contenido del correo HTML
                </label>
                <div style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>
                    Escribí o pegá tu código HTML aquí.
                </div>
                <textarea
                    rows={12}
                    value={htmlContenido}
                    onChange={(e) => setHtmlContenido(e.target.value)}
                    placeholder="<p>Hola <strong>{{nombre}}</strong>, este es tu mensaje...</p>"
                    style={{
                        width: "100%",
                        maxWidth: "100%",
                        padding: "12px",
                        fontFamily: "monospace",
                        fontSize: "14px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        boxSizing: "border-box",
                        backgroundColor: "#fdfdfd"
                    }}
                />
            </div>

            {/* RESULTADO */}
            {resultado && (
                <div style={{
                    marginTop: "20px",
                    padding: "20px",
                    borderRadius: "10px",
                    backgroundColor: resultado.ok === false ? "#fef2f2" : "#f0fdf4",
                    border: `1px solid ${resultado.ok === false ? "#fecaca" : "#bbf7d0"}`,
                    color: "#1f2937"
                }}>
                    <h3 style={{
                        margin: "0 0 12px 0",
                        fontSize: "16px",
                        color: resultado.ok === false ? "#991b1b" : "#166534"
                    }}>
                        {resultado.ok === false ? "❌ Error en el envío" : "✅ Envío exitoso"}
                    </h3>

                    <div style={{ display: "grid", gap: "8px", fontSize: "14px" }}>
                        {typeof resultado === "object" && !Array.isArray(resultado) ? (
                            Object.entries(resultado).map(([key, value]) => (
                                <div key={key} style={{ display: "flex", justifyBetween: "space-between" }}>
                                    <strong style={{ textTransform: "capitalize", color: "#4b5563" }}>{key}:</strong>
                                    <span>{typeof value === "object" ? JSON.stringify(value) : String(value)}</span>
                                </div>
                            ))
                        ) : (
                            <span>{String(resultado)}</span>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}